export default __webpack_public_path__ + "static/media/E01.50944aea.mp3";